








































import { Vue, Component, Prop } from "vue-property-decorator";
import { IMapLayer } from "@/components/map/types";
import { User } from "@/components/User";
import Map from "@/components/map/Map";
import { isMobile } from "@/common/utils";
//import TreeListUI from "@/components/shared/TreeListUI.vue";

const REPORT_ITEMS : IMapLayer[] = [{
    title: 'พื้นที่เกษตรและการขึ้นทะเบียน',
    //type: 'radio',
    //radioGroup: 'dashboard',
    checked: false,
    dashboard: true,
    uri: 'farmland_area',
    image: '/static/images/legend-chart-bubble.svg'
  },{
    title: 'พื้นที่เกษตรตามความเสี่ยงจากน้ำท่วม',
    //type: 'radio',
    //radioGroup: 'dashboard',
    checked: false,
    dashboard: true,
    uri: 'farmland_flooded',
    image: '/static/images/legend-chart-bubble.svg'
  },{
    title: 'พื้นที่เกษตรตามความเหมาะสมการปลูก',
    //type: 'radio',
    //radioGroup: 'dashboard',
    checked: false,
    dashboard: true,
    uri: 'farmland_suitability',
    image: '/static/images/legend-chart-bubble.svg'
  },{
    title: 'พื้นที่เกษตรตามสภาพของดิน',
    //type: 'radio',
    //radioGroup: 'dashboard',
    checked: false,
    dashboard: true,
    uri: 'farmland_soilclass',
    image: '/static/images/legend-chart-bubble.svg'
  },{
    title: 'พื้นที่เกษตรตามเขตชลประทาน',
    //type: 'radio',
    //radioGroup: 'dashboard',
    checked: false,
    dashboard: true,
    uri: 'farmland_in_rid_area',
    image: '/static/images/legend-chart-bubble.svg'
  },{
    title: 'พื้นที่เกษตรที่ทับซ้อนเขตป่า',
    //type: 'radio',
    //radioGroup: 'dashboard',
    checked: false,
    dashboard: true,
    uri: 'farmland_in_forest',
    image: '/static/images/legend-chart-bubble.svg'
  },{
    title: 'พื้นที่เกษตรตามเขต ส.ป.ก.',
    //type: 'radio',
    //radioGroup: 'dashboard',
    checked: false,
    dashboard: true,
    uri: 'farmland_in_alro',
    image: '/static/images/legend-chart-bubble.svg'
  },{
    title: 'การคาดการณ์ผลผลิตรายแปลง',
    subtitle: 'มันสำปะหลัง/ข้าวโพด/ข้าว/อ้อย',
    //type: 'radio',
    //radioGroup: 'dashboard',
    checked: false,
    dashboard: true,
    uri: 'farmland_yield',
    image: '/static/images/legend-chart-bubble.svg'
  },{
    title: 'การคาดการณ์ผลผลิตจากข้อมูลดาวเทียม',
    subtitle: 'มันสำปะหลัง/ข้าวโพด/ข้าว/อ้อย',
    //type: 'radio',
    //radioGroup: 'dashboard',
    checked: false,
    dashboard: true,
    uri: 'yield_forecast',
    image: '/static/images/legend-chart-bubble.svg'
  }];

@Component/*({
  components: {
    'v-tree-list': TreeListUI
  }
})*/
export default class Dashboard extends Vue {
  @Prop({
    default: null
  }) data: {$map:Map};

  $map: Map;
  items: IMapLayer[] = REPORT_ITEMS;

  get User() : User {
    return this.$store.getters.User;
  }

  get language() : string {
    return this.$store.getters.Language;
  };

  get WindowWidth() : number {
    return this.$store.getters.WindowWidth;
  }

  get isDesktop() : boolean {
    return !isMobile();
  }

  get isSmallOrMobile() : boolean {
    return isMobile() || this.WindowWidth<600;
  }

  created() {
    this.$map = this.data.$map;
    //this.items.forEach((item) => {
    //  item.doAction = this.doItemAction;
    //});
  }

  hideAllOthers(item) {
    this.items.forEach((itm) => {
      if (itm!=item) {
        itm.checked = false; 
        //todo hide map layer
      }
    });
  }

  doItemAction(item) {
    this.hideAllOthers(item);
    item.checked = true; //required to show report
    this.$emit('iWantToDo', {
      name: 'do_map_layer_action',
      data: {item:item, action:{action:'changeVisibility'}}
    });
  }

  toggleToc(toc) {
    this.$emit('iWantToDo', {
      name: 'toggle_toc',
      data: toc
    });
  }
}
